import { FC, useMemo } from "react";
import { useGetIntentContextTypesQuery } from "@/generated/taxonomy";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import { CheckboxListFilter } from "./CheckboxListFilter";

export interface ContextTypeCheckboxListProps {
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

export const ContextTypeCheckboxList: FC<ContextTypeCheckboxListProps> = ({
  selectedIds,
  onChange,
}) => {
  const { data, loading } = useGetIntentContextTypesQuery({
    context: { clientName: TAXONOMY_CLIENT },
  });

  const options = useMemo(() => data?.intentContextType?.data ?? [], [data]);

  return (
    <CheckboxListFilter
      options={options}
      loading={loading}
      selectedIds={selectedIds}
      onChange={onChange}
      emptyMessage="No context types available"
      skeletonCount={4}
    />
  );
};
